import { render } from "./Tal_pushList.vue?vue&type=template&id=39ed5dd8&scoped=true"
import script from "./Tal_pushList.vue?vue&type=script&lang=js"
export * from "./Tal_pushList.vue?vue&type=script&lang=js"

import "./Tal_pushList.vue?vue&type=style&index=0&id=39ed5dd8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ed5dd8"]])

export default __exports__